import {
  isOriginalLang,
  ORIGINAL_LANGUAGE,
} from '@src/utility/captionLanguage';
import { useSearchParams } from 'react-router-dom';

/**
 * PLAT-12204 — the language a Creator Studio publish delivers: the one the
 * page is showing (`?lang=`), which owns the caption language (DS8).
 *
 * Not the editor's caption config. That only follows `?lang=` once the
 * Captions panel or the transcript's captions view has opened, so a publish
 * read from it before then delivered the original language — no dub, no
 * translated captions — on a page showing a translation.
 */
export function usePublishLanguage(): string {
  const [searchParams] = useSearchParams();
  const lang = searchParams.get('lang');
  return lang && !isOriginalLang(lang) ? lang : ORIGINAL_LANGUAGE;
}
